// Global JavaScript that runs on every page
// Add analytics, service workers, or other non-Inertia JS here

console.log('Vite ⚡️ Rails')

// Register Service Worker for PWA functionality (production only)
// In development, the service worker caches Vite assets which causes stale code issues
const isDev = import.meta.env.DEV
if ('serviceWorker' in navigator && !isDev) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration.scope)

        // Check for updates periodically
        setInterval(() => {
          registration.update()
        }, 60000) // Check every minute
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error)
      })
  })
} else if (isDev && 'serviceWorker' in navigator) {
  // Unregister any existing service workers in development
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister()
      console.log('Service Worker unregistered for development')
    }
  })
}
